module.exports = __webpack_public_path__ + "media/images/new--a2e3992a487033fbcb88a52bd1110928.png";